import { Routes } from '@angular/router';

import { SelectKeypadComponent } from '../quickstart-keypads/select-keypad/select-keypad.component';
import { SelectRoomComponent } from './select-room/select-room.component';
import { SelectRemoteButtonComponent } from './select-remote-button/select-remote-button.component';

export const QUICKSTART_TRIGGERS_REMOTES_ROUTES: Routes = [{
  path: 'remotes', children: [{
    path: '', redirectTo: 'room', pathMatch: 'full'
  },{
    path: 'room', component: SelectRoomComponent
  }, {
    path: 'button', component: SelectRemoteButtonComponent
  }]
}];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-system-remotes/quickstart-system-remotes.routes.ts